import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export const SESSION_STATUS_OPTIONS = [
  { value: 'FINISHED', label: 'Finished' },
  { value: 'SCHEDULED', label: 'Scheduled' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'CANCELLED', label: 'Cancelled' },
  { value: 'TEACHER_NO_SHOW', label: 'Teacher No Show' },
  { value: 'STUDENT_NO_SHOW', label: 'Student No Show' },
  { value: 'STUDENT_AND_TEACHER_NO_SHOW', label: 'Student & Teacher No Show' },
  { value: 'JOINED_BUT_CANCELLED', label: 'Joined But Cancelled' },
  { value: 'NO_SHOW_CANCELLATION_1HOUR', label: 'No-Show Cancellation (1hr)' }
];

// Multi-select session-status dropdown; the selection lives in the URL via the parent.
function StatusMultiSelect({ selected, onChange }) {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const toggle = (value) => {
    const next = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    onChange(next);
  };

  const label = selected.length === 0 ? 'Status: All' : `Status: ${selected.length} selected`;

  return (
    <div className="tp-multiselect" ref={boxRef}>
      <button type="button" className="tp-multiselect-toggle" onClick={() => setOpen(!open)}>
        {label} <span aria-hidden="true">▾</span>
      </button>
      {open ? (
        <div className="tp-multiselect-menu">
          {SESSION_STATUS_OPTIONS.map((opt) => (
            <label key={opt.value} className="tp-multiselect-option">
              <input
                type="checkbox"
                checked={selected.includes(opt.value)}
                onChange={() => toggle(opt.value)}
              />
              <span>{opt.label}</span>
            </label>
          ))}
          {selected.length ? (
            <button
              type="button"
              className="link-btn tp-multiselect-clear"
              onClick={() => onChange([])}
            >
              Clear
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

StatusMultiSelect.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired
};

export default StatusMultiSelect;
